import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { ArztDatenResponse, ClientService } from '../../api/client.service';

@Component({
  selector: 'san-infotext-arztdaten-qrtne',
  templateUrl: './infotext-arztdaten-qrtne.component.html',
  styleUrls: ['./infotext-arztdaten-qrtne.component.scss'],
  standalone: false,
})
export class InfotextArztdatenQRTNEComponent implements OnInit {
  sending: unknown;
  spinnerIcon = faSpinner;

  @Input() uuid: string;
  @Input() versorgungsVertragID: number;
  @Input() vertragsgruppe: number;
  @Input() state: ArztDatenResponse;
  @Input() krankenkassen: { name: string; id: number }[];

  @Output() weiterClicked = new EventEmitter();

  loading = true;
  error = false;

  constructor(private vvApi: ClientService) {}

  ngOnInit(): void {}

  onWeiterClicked() {
    this.weiterClicked.emit();
  }

  ladeArztDaten() {
    // only once
    if (this.state && this.state.arzt) {
      return;
    }
    this.loading = true;
    this.vvApi
      .getArztDaten(this.uuid, this.versorgungsVertragID, this.vertragsgruppe)
      .subscribe(
        (response) => {
          this.state.arzt = response.arzt;
          this.state.vertrag = {
            name: response.vertrag_name,
            text_teilnahmeerklaerung_selbsteinschreibung: '',
            text_teilnahmeerklaerung_datenschutz_selbsteinschreibung: '',
            text_bedingungen_selbsteinschreibung: '',
            text_therapieinhalte_selbsteinschreibung: '',
            tnz_nur_nach_ae: true,
            text_widerruf_selbsteinschreibung: '',
          };
          for (const kk of response.krankenkassen) {
            this.krankenkassen.push(kk);
          }
          this.loading = false;
        },
        () => {
          this.error = true;
          this.loading = false;
        },
      );
  }
}
